import { useNavigate, useParams } from '@tanstack/react-router';
import { CopyPlus } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { formatDate, formatHours } from '@/lib/format';
import { useFormat } from '@/lib/use-format';
import { CopyWeekDialog } from './copy-week-dialog';
import { TimeNav } from './time-nav';
import { WeekGrid } from './week-grid';

/** The signed-in user's week timesheet. */
export function WeekView() {
  const { t } = useTranslation();
  const fmt = useFormat();
  const navigate = useNavigate();
  const { date } = useParams({ from: '/app/time/week/$date' });
  const [copyOpen, setCopyOpen] = useState(false);

  return (
    <>
      <WeekGrid
        date={date}
        header={(week) => (
          <TimeNav
            view="week"
            anchor={date}
            title={
              week
                ? t('time.weekOf', { date: formatDate(week.weekStart, fmt) })
                : t('time.weekView')
            }
            total={formatHours(week?.weekTotal ?? 0, fmt)}
          >
            <Button variant="secondary" onClick={() => setCopyOpen(true)}>
              <CopyPlus /> {t('time.copy.action')}
            </Button>
          </TimeNav>
        )}
      />
      <CopyWeekDialog
        open={copyOpen}
        onOpenChange={setCopyOpen}
        sourceDate={date}
        onCopied={(result) =>
          void navigate({ to: '/time/week/$date', params: { date: result.targetWeekStart } })
        }
      />
    </>
  );
}
